/* eslint-disable */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable arrow-body-style */
import { ArrowDownTrayIcon, ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import { Button, Container, Nav } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import { useUser } from "../UserContext";

import { ReactComponent as DownloadIcon } from "../../assets/icons/Download_Icon.svg";
import { ReactComponent as HelpIcon } from "../../assets/icons/Help_Icon.svg";
import { reportNavLinks } from "./helpers/reportHelpers";

const ReportNav = ({ handleClose }) => {
	const { user } = useUser();

	return (
		<Container className="profile__nav bg-primary">
			<div className="logo-container profile__sidebar-section align-items-center d-flex justify-content-between">
				<img 
					alt="LOGO"
					className="logo"
					height="152"
					src="/eqqo_logo.png"
					width="472"
				/>
				<Button className="nav-menu-button" onClick={handleClose}>X</Button>
			</div>
			<Nav as="nav" className="report-nav-list profile__sidebar-section flex-column fs-16 m-0" >
				{
					user?.eqqoProfile?.reportInstructionsConfirmed
						? (
							<>
								{Object.entries(reportNavLinks).map(([key, navLink]) => (
									<Nav.Item key={key}>
										<NavLink 
											className="nav-link"
											to={`/report/${key}`}
										>
											{navLink.icon}
											<span className="nav-step-label flex-fill">{navLink.label}</span>
											<ChevronRightIcon />
										</NavLink>
									</Nav.Item>
								))}
							</>
						)
						: null
				}
				<Nav.Item>
					<NavLink className="nav-link text-white py-2" to="/profile/help">
						<HelpIcon />
						<span className="flex-fill">Help</span>
						<ChevronRightIcon />
					</NavLink>
				</Nav.Item>
			</Nav>
			{
				user?.eqqoProfile?.reportInstructionsConfirmed
					? (
						<div className="profile__sidebar-section mb-3">
							<Button as={Link} className="nav-link text-white d-flex justify-content-between p-0 w-100" to="/report/print" variant="link">
								<span>Download/Print Report</span>
								<DownloadIcon />
							</Button>
						</div>
					)
					: null
			}

			<Nav.Item className="mt-auto profile__sidebar-section">
				<NavLink className="nav-link text-white" to="/profile/dashboard">
					<ChevronLeftIcon />
					Back to Dashboard
				</NavLink>
			</Nav.Item>
		</Container>
	);
};


ReportNav.propTypes = {
	activeSection: PropTypes.number,
	handleClose: PropTypes.func
};

ReportNav.defaultProps = {
	activeSection: 1,
	handleClose: null
}

export default ReportNav;
